import { JSX } from "preact/jsx-runtime";
import { email as emailValidation } from "https://deno.land/x/validation@v0.4.0/mod.ts";
import { useSignal } from "@preact/signals";

const EarlyAccessForm = () => {
    const status = useSignal<string>("");
    const isLoading = useSignal<boolean>(false); // Add a new state for loading

    const handleSubmit = async (e: JSX.TargetedEvent<HTMLFormElement>) => {
        e.preventDefault();
        
        const form = e.currentTarget;
        const emailInputElement = form.elements.namedItem('email') as HTMLInputElement | null;
    
        if (emailInputElement && emailValidation.valid(emailInputElement.value)) {
            isLoading.value = true; // Set loading to true
            const emailValue = emailInputElement.value;
    
            try {
                const response = await fetch("/api/early-access", {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify({ email: emailValue }),
                });
    
                if (response.ok) {
                    //console.log("Email submitted successfully!");
                    status.value = "E-mail submitted successfully!";
                    emailInputElement.value = "";
                } else {
                    //console.error("Failed to submit email. Server responded with:", response.status, response.statusText);
                    status.value = "Failed to submit email. Try again.";
                    emailInputElement.focus();
                }
            } catch (error) {
                //console.error("Error submitting email:", error);
                status.value = "Error submitting email. Try again.";
                emailInputElement.focus();
            } finally {
                isLoading.value = false; // Set loading back to false regardless of success or error
            }
        } else {
            status.value = "Type a valid email and try again";
            if (emailInputElement) emailInputElement.focus();
        }
    }

    return (
        <>
        <form className="flex flex-wrap items-center mt-12 justify-start" onSubmit={handleSubmit}>
            <input
              placeholder="Your e-mail address"
              className="w-96 text-3xl p-4"
              name="email"
            />
            <button
            type="submit"
              className="flex-none p-4 bg-[#2251ff] text-[#FFF] text-3xl hover:bg-[#1d3db6] transition-all duration-500"
              disabled={isLoading.value}  // Disable button when loading
            >
              {isLoading.value ? "Processing..." : "Request early access"} 
            </button>
        </form>
        <div className={"h-6 mt-1 text-[#FFF]"}>{status.value}</div>
        </>
    );
}

export default EarlyAccessForm;